
<div :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libDateDeNaissance"
    :rules="`required|is_valid_date|is_age_requis`"
    tag="div"
  >
    <!-- TODO:
    vee-validate V3 ne supporte plus date_format : custom validation?
    rules="required|date_format:yyyy/MM/dd|date_between:2016/10/09,2020/20/09"
  -->
    <b-form-group :label="content.libDateDeNaissance" label-for="dateDeNaissance">
      <b-form-input
        :id="content.idHTML ? content.idHTML : 'dateDeNaissance'"
        v-model="dateDeNaissance"
        type="tel"
        class="text-center font-weight-bold texte"
        :maxlength="$t('compte.dateDeNaissance.placeholder').length"
        :state="getValidationState(validationContext)"
        @keydown.enter="getValidationState(validationContext)"
        @keyup.native="maskDateDeNaissance($event)"
      ></b-form-input>
      <ErreurValidation
        id="dateDeNaissance-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
</div>
